import React, { useEffect, useState } from "react";
import api, { inr } from "../../lib/api";

export default function AdminOrders() {
    const [orders, setOrders] = useState([]);
    useEffect(() => {
        document.title = "Admin Orders | Loomara";
        api.get("/admin/orders").then(({ data }) => setOrders(data));
    }, []);

    return (
        <div data-testid="admin-orders-page">
            <p className="eyebrow">Fulfilment</p>
            <h1 className="font-serif text-4xl text-ink-900 mt-2 mb-8">Orders</h1>

            <div className="card-soft overflow-hidden">
                {orders.length === 0 ? (
                    <p className="p-10 text-center text-ink-500">No orders yet.</p>
                ) : (
                    <table className="w-full text-sm">
                        <thead className="bg-ivory-100 text-ink-700">
                            <tr>
                                <th className="text-left px-6 py-4 font-medium tracking-wider uppercase text-[11px]">Order</th>
                                <th className="text-left px-6 py-4 font-medium tracking-wider uppercase text-[11px]">Customer</th>
                                <th className="text-left px-6 py-4 font-medium tracking-wider uppercase text-[11px]">Items</th>
                                <th className="text-left px-6 py-4 font-medium tracking-wider uppercase text-[11px]">Total</th>
                                <th className="text-left px-6 py-4 font-medium tracking-wider uppercase text-[11px]">Status</th>
                                <th className="text-left px-6 py-4 font-medium tracking-wider uppercase text-[11px]">Shiprocket</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-sage-300/20">
                            {orders.map((o) => (
                                <tr key={o.id} className="hover:bg-ivory-100/50" data-testid={`admin-order-${o.orderNumber}`}>
                                    <td className="px-6 py-3 text-ink-900">#{o.orderNumber}</td>
                                    <td className="px-6 py-3 text-ink-700">{o.customerName}<br /><span className="text-xs text-ink-500">{o.customerEmail}</span></td>
                                    <td className="px-6 py-3 text-ink-700">{o.items.length}</td>
                                    <td className="px-6 py-3 text-sage-700">{inr(o.total)}</td>
                                    <td className="px-6 py-3">
                                        <span className={`text-[10px] uppercase tracking-[0.22em] px-3 py-1 rounded-full ${o.paymentStatus === "paid" ? "bg-sage-100 text-sage-700" : "bg-ivory-100 text-ink-500"}`}>
                                            {o.status} · {o.paymentStatus}
                                        </span>
                                    </td>
                                    <td className="px-6 py-3 text-xs text-ink-500">
                                        {o.shiprocketOrderId ? `#${o.shiprocketOrderId}` : (o.shiprocket?.note || "—")}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}
